import { Component, inject } from "@angular/core";
import { CalendarDataService } from "@app/calendar/services/calendar-data.service";

@Component({
    selector: "navbar-calendar",
    templateUrl: "./navbar-calendar.component.html",
    styleUrls: ["../navbar-plugin-base.scss", "./navbar-calendar.component.scss"],
    standalone: false
})
export class NavbarCalendarComponent {
    private _calendarDS = inject(CalendarDataService);

    get todoCount() {
        return this._calendarDS.calendarModel ? this._calendarDS.calendarModel.todoCount : 0;
    }
}
